<div class="container mt-4">
  <div class="form-group">
    <label>Description</label>
    <input class="form-control" [(ngModel)]="description" />
  </div>

  <div *ngFor="let prop of properties; let i = index" class="row mb-2">
    <div class="col">
      <input class="form-control" placeholder="Label" [(ngModel)]="prop.label" />
    </div>
    <div class="col">
      <select class="form-control" [(ngModel)]="prop.TemplateValueType">
        <option *ngFor="let type of valueTypes" [value]="type.ValidVal">{{ type.ValidVal }}</option>
      </select>
    </div>
    <div class="col">
      <input class="form-control" placeholder="Value" [(ngModel)]="prop.value" />
    </div>
    <div class="col-auto">
      <button class="btn btn-danger" (click)="deleteProperty(i)">Delete</button>
    </div>
  </div>

  <button class="btn btn-secondary mb-3" (click)="addProperty()">Add Property</button>
  <button class="btn btn-success" (click)="save()">Save Changes</button>
</div>
